import { guestPeople, people, type Person } from './mock';
import { useStore, type Onboarding } from '../state/store';

const guestMe: Person = { id: 'me', name: 'Paul Schreiber', avatar: 'coral' };

/** The signed-in user, with what they entered during onboarding taking precedence. */
function meFor(hasOrg: boolean, profile: Onboarding): Person {
  const base = hasOrg ? people.me! : guestMe;
  return {
    ...base,
    name: profile.name.trim() || base.name,
    title: profile.title.trim() || (profile.name.trim() ? undefined : base.title),
    photo: profile.photo,
  };
}

export function personFor(id: string, hasOrg: boolean, profile: Onboarding): Person {
  if (id === 'me') return meFor(hasOrg, profile);
  return people[id] ?? guestPeople[id] ?? { id, name: 'Unknown', avatar: 'blue' };
}

export function usePerson(id: string): Person {
  const hasOrg = useStore((s) => s.orgId !== null);
  const profile = useStore((s) => s.onboarding);
  return personFor(id, hasOrg, profile);
}

export function usePersonLookup(): (id: string) => Person {
  const hasOrg = useStore((s) => s.orgId !== null);
  const profile = useStore((s) => s.onboarding);
  return (id) => personFor(id, hasOrg, profile);
}
